GameView = require "views/base/game"
animate  = require("lib/animate")
Easie    = require("lib/easie")

class NumberPickerView extends GameView
  templates:
    default: require("./template")
    wrapper: require("./components/wrapper")
    digits:  require("./components/digits")

  events:
    "iostap   .btn-up": "increase"
    "iostap .btn-down": "decrease"
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super
    { question, answers } = data.metadata.questions[0]
    { decimals, numbers } = data
    data.correct = _.find numbers, 'correct'

    for answer, i in answers
      answers[i].content = 0 if answer.content == ''
    
    data.answers = _.sortBy(answers, ({ content }) -> parseFloat(content) or 0)

    zero = (0).toFixed(decimals or 0)
    data.sentence = question.content.replace /#+/, @templates.wrapper({ zero })

    return data

  onRefresh: ->
    @beforeShow()
    super

  beforeShow: ->
    @setEl @findOne(".btn-up"),   "up"
    @setEl @findOne(".btn-down"), "down"
    @setEl @findOne(".number"),   "number"

    @currentIndex = _.random(@options.metadata.questions[0].answers.length - 1)
    @animateChange 0

    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  show: ->
    super

    @enterGame()

  increase: ->
    values = @serialize().answers
    prev   = values[@currentIndex].content
    @currentIndex = Math.min (values.length - 1), @currentIndex + 1

    @animateChange(prev)
    @setState("touched")

  decrease: ->
    values = @serialize().answers
    prev   = values[@currentIndex].content
    @currentIndex = Math.max 0, @currentIndex - 1

    @animateChange(prev, null, -1)
    @setState("touched")

  animateChange: (prev, next, dir = 1) ->
    { answers, decimals } = @serialize()

    el    = @getEl("number")
    limit = answers.length - 1
    next ?= answers[@currentIndex].content

    if decimals is 0
      next = Math.round(next)
      prev = Math.round(prev)

    w1 = el.offsetWidth
    nb = el.innerHTML
    el.innerHTML = written.prettyNumber(next, ",", decimals)
    w2 = el.offsetWidth
    el.innerHTML = nb

    @getEl("down").classList.toggle "disabled", @currentIndex is 0
    @getEl("up").classList.toggle "disabled", @currentIndex is limit

    if not decimals?
      shouldInterpolateDecimalPlaces = true
      d1 = prev.toString().replace(/\d+\.{0,1}/, "").length
      d2 = next.toString().replace(/\d+\.{0,1}/, "").length

    pStr = written.prettyNumber(prev, ",", decimals)
    nStr = written.prettyNumber(next, ",", decimals)

    dur   = 0.66
    yDist = -4
    xDist = 0

    # As we animate between the two numbers, the length of the string could
    # change. For new digits, translate them in from the 20px left while
    # increasing their opacity. Gradually change the width of the container at
    # the same time.
    draw = (d) =>
      eez = Easie.quartInOut(d, 0, 1, 1)
      num = new window.Big(next).minus(prev).times(eez).plus(prev)
      num = num.round() if decimals is 0

      if shouldInterpolateDecimalPlaces
        decimals = Math.round(d1 + (d2 - d1) * d)
        decimals = d2 if d is 1

      str = written.prettyNumber(num, ",", decimals)
      str = str.slice(0, Math.max(nStr.length, pStr.length))

      digits =
        for k, i in str
          ln = str.length
          start = i / ln * (1 - dur)
          clamp = _.limit(d - start, dur)
          yDiff = Easie.quartIn Math.sin(clamp / dur * Math.PI), 0, 1, 1

          { text: k, y: yDiff * yDist * dir }

      if d < 1
        # If the new string lacks characters, add them so they can animate in
        if str.length < pStr.length
          diff = pStr.length - str.length - 1
          for i in [diff..0]
            digits.unshift text: pStr[i]

        else if str.length < nStr.length
          diff = nStr.length - str.length - 1
          for i in [diff..0]
            digits.unshift text: nStr[i]

        # For any changing characters, offset their opacity and x position
        if nStr.length > pStr.length
          diff = nStr.length - pStr.length
          for i in [0...diff]
            digits[i].opacity = d
            digits[i].x = (1 - eez) * xDist * (1 - i / diff)

        if pStr.length > nStr.length
          diff = pStr.length - nStr.length
          for i in [0...diff]
            digits[i].opacity = 1 - d
            digits[i].x = (eez) * xDist * (1 - i / diff)

      el.innerHTML = @templates.digits({ digits })

    @animation?.cancel()
    @animation = animate(draw, if @currentState?.refresh then 0 else 900)

  isCorrect: ->
    answer = @serialize().answers[@currentIndex]
    answer?.correct or answer.content is @serialize().correct?.number

  endGame: ->
    super
    @submit()

    if not @isCorrect()
      { numbers } = @serialize()
      prev = numbers[@currentIndex].number
      next = _.find(numbers, { correct: true })?.number
      @animateChange(prev, next)

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0
    [
      question: questions[0].question
      answer: @serialize().answers[@currentIndex]
      correct: @isCorrect()
    ]

module.exports = NumberPickerView
